module.exports = __webpack_public_path__ + "static/img/pickup-singlecab-grey.4e3a348.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-singlecab-grey.svg
// module id = su0m
// module chunks = 74